<header class="ao-page-head">
  <div>
    <div class="ao-eyebrow">Inter-store inventory</div>
    <h2>Borrowing</h2>
  </div>
  <div class="ao-borrow-legend">
    <span><i class="ao-dot"></i>On Loan</span>
    <span><i class="ao-dot ao-dot-due"></i>Reimbursement Due</span>
    <span><i class="ao-dot ao-dot-done"></i>Settled / Sent Back</span>
  </div>
</header>

<mat-card appearance="outlined" *ngIf="borrowingStore">
  <mat-toolbar class="ao-section-bar borrow-direction-bar" (click)="incomingOpen = !incomingOpen">
    <span class="borrow-direction-title">{{ otherStoreName }} TO {{ currentStore.storeName }}</span>
    <svg class="borrow-chev" [class.open]="incomingOpen" viewBox="0 0 24 24" aria-hidden="true">
      <path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"/>
    </svg>
  </mat-toolbar>
  <mat-card-content [hidden]="!incomingOpen">
    <app-borrowing-vendors
      [borrowingStore]="0"
      [locationPhrase]="'frames currently at ' + currentStore.storeName"
      [returnLabel]="'Send Back to ' + otherAbbreviation"
      [returnStoreName]="otherStoreName"
      (framesChange)="incomingFrames = $event"
    ></app-borrowing-vendors>
  </mat-card-content>
</mat-card>

<mat-card appearance="outlined" *ngIf="borrowingStore">
  <mat-toolbar class="ao-section-bar borrow-direction-bar" (click)="outgoingOpen = !outgoingOpen">
    <span class="borrow-direction-title">{{ currentStore.storeName }} TO {{ borrowingStore.storeName }}</span>
    <span class="borrow-direction-tools" *ngIf="storeOptions?.length > 2" (click)="$event.stopPropagation()">
      <mat-select placeholder="BORROWING" [(value)]="borrowingStore._id">
        <ng-container *ngFor="let storeOption of storeOptions">
          <mat-option *ngIf="storeOption._id !== currentStore._id" [value]="storeOption._id">
            {{ storeOption.storeName }}
          </mat-option>
        </ng-container>
      </mat-select>
    </span>
    <svg class="borrow-chev" [class.open]="outgoingOpen" viewBox="0 0 24 24" aria-hidden="true">
      <path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"/>
    </svg>
  </mat-toolbar>
  <mat-card-content [hidden]="!outgoingOpen">
    <app-borrowing-vendors
      [borrowingStore]="borrowingStore._id"
      [locationPhrase]="'frames currently at ' + borrowingStore.storeName"
      [returnLabel]="'Send Back to ' + currentAbbreviation"
      [returnStoreName]="currentStore.storeName"
      (framesChange)="outgoingFrames = $event"
    ></app-borrowing-vendors>
  </mat-card-content>
</mat-card>

<section class="borrow-summary" *ngIf="borrowingStore">
  <div class="borrow-summary-head">
    <div class="borrow-summary-title">{{ summaryTitle }}</div>
    <div class="borrow-period">
      <button type="button" [class.active]="period === 'day'" (click)="period = 'day'">Day</button>
      <button type="button" [class.active]="period === 'week'" (click)="period = 'week'">Week</button>
      <button type="button" [class.active]="period === 'month'" (click)="period = 'month'">Month</button>
    </div>
  </div>
  <div class="borrow-totals">
    <span>{{ currentStore.storeName }} owes {{ otherStoreName }} <strong>{{ incomingDue | currency }}</strong></span>
    <span>{{ otherStoreName }} owes {{ currentStore.storeName }} <strong>{{ outgoingDue | currency }}</strong></span>
    <span>Reference difference <strong>{{ referenceLabel }}</strong></span>
  </div>
  <p class="borrow-note">Each direction remains separately reported. Whether the stores may settle only the difference should be confirmed with the accountant because they use separate EINs.</p>
</section>

<mat-card appearance="outlined" *ngIf="currentRentalUser">
  <mat-toolbar class="ao-section-bar borrow-direction-bar" (click)="rentalOpen = !rentalOpen">
    <span class="borrow-direction-title">RENTING {{ currentStore.storeName }} TO {{ currentRentalUser.name }}</span>
    <span class="borrow-direction-tools" (click)="$event.stopPropagation()">
      <mat-select placeholder="RENTING" [value]="currentRentalUser._id" (selectionChange)="changeRentalUser($event)">
        <mat-option *ngFor="let rentalUser of rentalUsers" [value]="rentalUser._id">
          {{ rentalUser.name }}
        </mat-option>
      </mat-select>
    </span>
    <svg class="borrow-chev" [class.open]="rentalOpen" viewBox="0 0 24 24" aria-hidden="true">
      <path d="m6 9 6 6 6-6" fill="none" stroke="currentColor" stroke-width="2"/>
    </svg>
  </mat-toolbar>
  <mat-card-content [hidden]="!rentalOpen">
    <app-borrowing-vendors
      [rentingUser]="currentRentalUser._id"
      [locationPhrase]="'frames currently with ' + currentRentalUser.name"
    ></app-borrowing-vendors>
  </mat-card-content>
</mat-card>
